import React, { useState } from 'react';
import './Contact.css';
import ContactIMG from '../Images/Buddha.webp';
import Alert from '../Alert/Alert';

function Contact() {
  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    email: '',
    phone: '',
    subject: '',
    comment: ''
  });

  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value
    }));
  };

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    const charStr = String.fromCharCode(charCode);

    if (!/[0-9+\s]/.test(charStr)) {
      e.preventDefault();
      return;
    }

    if (charStr === ' ' && e.target.value[e.target.value.length - 1] === ' ') {
      e.preventDefault();
      return;
    }
  };

  const sanitizeInput = (input) => {
    return input.replace(/[<>/'"\\;]/g, '');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    const sanitizedData = {
          lastName: sanitizeInput(formData.lastName.trim()),
          firstName: sanitizeInput(formData.firstName.trim()),
          email: sanitizeInput(formData.email.trim()),
          phone: sanitizeInput(formData.phone.trim()),
          subject: sanitizeInput(formData.subject.trim()),
          comment: sanitizeInput(formData.comment.trim())
        };
  
        if (!sanitizedData.lastName || !sanitizedData.firstName || !sanitizedData.email || !sanitizedData.phone || !sanitizedData.subject || !sanitizedData.comment) {
          setAlert({ show: true, message: 'Veuillez remplir tous les champs du formulaire.', type: 'error' });
          return;
        }
  
        setIsButtonDisabled(true);
  
        const url = '/api/v1/contact'; 
  
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(sanitizedData),
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`La réponse du réseau n'était pas correcte: ${response.statusText}`);
          }
          return response.json();
        })
        .then(data => {
          if (data.message === 'Formulaire envoyé avec succès.') {
            setAlert({ show: true, message: 'Formulaire envoyé avec succès.', type: 'success' });
          } else {
            setAlert({ show: true, message: 'Erreur lors de l\'envoi du formulaire.', type: 'error' });
          }
          setTimeout(() => setIsButtonDisabled(false), 30000);
        })
        .catch(error => {
          setAlert({ show: true, message: 'Erreur lors de l\'envoi du formulaire.', type: 'error' });
          setTimeout(() => setIsButtonDisabled(false), 30000);
        });
  };

  return (
    <div className='background-contact'>
      {alert.show && (
        <Alert 
          message={alert.message} 
          type={alert.type} 
          onClose={() => setAlert({ ...alert, show: false })} 
        />
      )}
      <div className='container-contact'>
        <div className='container-left'>
          <h2>Contactez-nous</h2>
          <p>Nous sommes à votre disposition pour<br />toute demande de renseignements ou de services.</p>
          <form onSubmit={handleSubmit}>
            <div className='container-1'>
              <div className='input-box'>
                <label htmlFor="lastName">Nom</label>
                <input type="text" id="lastName" value={formData.lastName} onChange={handleChange} />
              </div>
              <div className='input-box'>
                <label htmlFor="firstName">Prénom</label>
                <input type="text" id="firstName" value={formData.firstName} onChange={handleChange} />
              </div>
            </div>
            <div className='container-2'>
              <div className='input-box'>
                <label htmlFor="email">E-mail</label>
                <input type="email" id="email" value={formData.email} onChange={handleChange} />
              </div>
              <div className='input-box'>
                <label htmlFor="phone">Numéro de téléphone</label>
                <input type="text" id="phone" value={formData.phone} onChange={handleChange} onKeyPress={handleKeyPress} />
              </div>
            </div>
            <div className='container-3'>
              <div className='input-box'>
                <label htmlFor="subject">Objet</label>
                <input type="text" id="subject" value={formData.subject} onChange={handleChange} />
              </div>
              <div className='input-box'>
                <label htmlFor="comment">Commentaire</label>
                <textarea id="comment" value={formData.comment} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className='container-btn'>
              <button type="submit" disabled={isButtonDisabled}>Envoyer</button>
            </div>
          </form>
        </div>
        <div className='container-right'>
          <img src={ContactIMG} alt="Statue de Bouddha" loading="lazy" decoding="async" />
        </div>
      </div>
    </div>
  );
}

export default Contact;
